/**
 * PageHero — a shared page-header component used across major pages to give the
 * app a unified medical-tech "one platform" feel.
 *
 * Usage:
 *   <PageHero
 *     eyebrow="Command"
 *     title="Dashboard"
 *     subtitle="Your protocol at a glance"
 *     icon={<Zap className="w-5 h-5 text-[#0D9488]" />}
 *     actions={<Button>New shot</Button>}
 *   />
 */
export default function PageHero({
  eyebrow,
  title,
  subtitle,
  icon,
  actions,
  gradient = false,
}) {
  return (
    <div
      className={[
        "relative mb-6 pb-5",
        gradient ? "border-b border-slate-200/60" : "",
      ].join(" ")}
      data-testid="page-hero"
    >
      {gradient && (
        <div
          aria-hidden
          data-page-hero-glow
          className="absolute inset-x-0 -top-6 h-32 pointer-events-none"
        />
      )}
      <div className="relative flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          {eyebrow && (
            <div
              className="font-mono-num text-[11px] uppercase tracking-[0.3em] text-[#0D9488] mb-2"
              data-testid="page-hero-eyebrow"
            >
              // {eyebrow}
            </div>
          )}
          <h1
            className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.9] flex items-center gap-3 text-slate-900"
            data-testid="page-hero-title"
          >
            {icon}
            {title}
          </h1>
          {subtitle && (
            <p className="text-slate-500 mt-3 text-sm max-w-2xl">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-wrap w-full sm:w-auto sm:shrink-0" data-testid="page-hero-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
